import VideoSliderView from "./Components/new/VideoSliderView.vue";
import {store} from "./store";
export default class VideoSlider {
    constructor () {
      new Vue({
        el: '#videoSlider',
        store,
        components: {
          VideoSliderView,
        },
      })
    }
}

$(document).on("ready", () => (window.VideoSlider = new VideoSlider()));



// WEBPACK FOOTER //
// ./resources/js/VideoSlider.js